// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1TjW3","addWidgetButton":"Header_addWidgetButton__3ZOPu","dashboardTabs":"Header_dashboardTabs__1YyLN","active":"Header_active__1wj8c"};